import styled from "styled-components";

export const UnderlinedLink = styled.a`
  text-decoration: underline;
`;
